// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"28cb0dcd","981":"676a5b1f"}[chunkId] + ".chunk.js";
};